var map = {
	"./azure.png": 64625,
	"./chatbox-ai.png": 14346,
	"./chatglm-6b.png": 57171,
	"./claude.png": 33364,
	"./deepseek.png": 20780,
	"./gemini.png": 53283,
	"./groq.png": 98345,
	"./lm-studio.png": 63328,
	"./mistral-ai.png": 41065,
	"./ollama.png": 96880,
	"./openai.png": 98828,
	"./openrouter.png": 87441,
	"./perplexity.png": 38368,
	"./siliconflow.png": 11823,
	"./volcengine.png": 49142,
	"./xAI.png": 2918,
	"renderer/static/icons/providers/azure.png": 64625,
	"renderer/static/icons/providers/chatbox-ai.png": 14346,
	"renderer/static/icons/providers/chatglm-6b.png": 57171,
	"renderer/static/icons/providers/claude.png": 33364,
	"renderer/static/icons/providers/deepseek.png": 20780,
	"renderer/static/icons/providers/gemini.png": 53283,
	"renderer/static/icons/providers/groq.png": 98345,
	"renderer/static/icons/providers/lm-studio.png": 63328,
	"renderer/static/icons/providers/mistral-ai.png": 41065,
	"renderer/static/icons/providers/ollama.png": 96880,
	"renderer/static/icons/providers/openai.png": 98828,
	"renderer/static/icons/providers/openrouter.png": 87441,
	"renderer/static/icons/providers/perplexity.png": 38368,
	"renderer/static/icons/providers/siliconflow.png": 11823,
	"renderer/static/icons/providers/volcengine.png": 49142,
	"renderer/static/icons/providers/xAI.png": 2918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2552;